/**
 * Nombres de peces y señas de identificación: español.
 *
 * ⚠️ NOMBRES DE USO REAL, NO TRADUCCIONES LITERALES. El pescador busca «lucio»,
 * «barbo», «carpa» o «black bass» — este último se dice así en España aunque
 * sea inglés, y escribir «perca de boca grande» sonaría a manual mal traducido.
 *
 * Para las especies de Siberia, el Amur y el Caspio no hay nombre castellano
 * asentado: se usa el nombre del libro, cercano al latín, para que ambos se
 * puedan cotejar.
 *
 * Sobre por qué este archivo va aparte y por qué aquí no hay latín, véase
 * species-north-ru.ts.
 */
export const РЫБЫ_ES: Record<string, string> = {
  // ── ciprínidos ──────────────────────────────────────────────────────────
  'fish.bream': 'brema',
  'fish.bream_look':
    'Alta y plana como una mano, de bronce oscuro. Va en bancos por los fondos de limo y el borde de las fosas.',
  'fish.silver_bream': 'brema blanca',
  'fish.silver_bream_look':
    'Parece una brema joven, pero las aletas tiran a rojo y la escama es mayor. No se despega del fondo.',
  'fish.blue_bream': 'brema azul',
  'fish.blue_bream_look':
    'Estrecha y alta, de dorso azulado y aleta anal muy larga. Anda a media agua, no en el fondo.',
  'fish.white_bream': 'brema de ojo blanco',
  'fish.white_bream_look':
    'Plateada, con un ojo grande y lechoso y el morro romo. Busca la corriente sobre arena limpia.',
  'fish.carp': 'carpa',
  'fish.carp_look':
    'Gruesa, pardo dorada, con dos pares de barbillas. Escarba el somero y se delata por la turbiedad.',
  'fish.wild_carp': 'carpa salvaje',
  'fish.wild_carp_look':
    'La carpa sin domesticar: más estilizada, más oscura y mucho más brava. Vive entre troncos y cañas.',
  'fish.crucian': 'carpín',
  'fish.crucian_look':
    'Redondo, dorado, sin barbilla alguna. Está en las calas con hierba y en las balsas enfangadas.',
  'fish.gibel_carp': 'carpín plateado',
  'fish.gibel_carp_look':
    'Plateado, más plano que el dorado, con la espina dorsal dentada. Vive allí donde haya agua.',
  'fish.roach': 'bermejuela común',
  'fish.roach_look':
    'Plateada, con el ojo rojo y las aletas anaranjadas. Se agrupa junto al borde de la hierba.',
  'fish.kutum': 'kutum',
  'fish.kutum_look':
    'Un rutilo grande y oscuro de los ríos del Caspio, de labios gruesos. Come almeja en los bajíos.',
  'fish.rudd': 'gardí',
  'fish.rudd_look':
    'Dorado, con las aletas escarlata y la boca hacia arriba. Come en superficie sobre la vegetación.',
  'fish.ide': 'cacho ide',
  'fish.ide_look':
    'Recio, de bronce claro y aletas carmesí. Se pone en la línea entre la corriente y el remanso.',
  'fish.chub': 'cacho',
  'fish.chub_look':
    'Cabezón, de escama grande y oscura y cola roja. Se esconde bajo los arbustos que cuelgan.',
  'fish.dace': 'leucisco',
  'fish.dace_look': 'Pequeño, plateado, de cuerpo fino y boca recta. Se pone en las tablas de arena.',
  'fish.tench': 'tenca',
  'fish.tench_look':
    'Verde oscura y viscosa, con barbillas diminutas y ojo rojo. Hurga en el légamo junto al cañaveral.',
  'fish.nase': 'boga de río',
  'fish.nase_look':
    'Dorso oscuro, boca transversal por debajo, peritoneo negro. Raspa las piedras en la corriente fuerte.',
  'fish.barbel': 'barbo',
  'fish.barbel_look':
    'Cuerpo de torpedo, cuatro barbillas, boca inferior. Se tumba en el fondo de los rápidos de piedra.',
  'fish.dnieper_barbel': 'barbo del Dniéper',
  'fish.dnieper_barbel_look':
    'El barbo de los rápidos del Dniéper, más oscuro y corto que el común. Aguanta tras las piedras.',
  'fish.grass_carp': 'carpa herbívora',
  'fish.grass_carp_look':
    'Larga y cilíndrica, de frente ancha. Pasta en los herbazales y siega el carrizo tierno.',
  'fish.black_carp': 'carpa negra',
  'fish.black_carp_look':
    'Casi negra como el hierro, con dientes faríngeos enormes. Tritura almejas en el fondo.',
  'fish.silver_carp': 'carpa plateada',
  'fish.silver_carp_look':
    'Plateada, frente ancha, ojos muy bajos. Va a media agua y salta fuera del agua con cualquier ruido.',
  'fish.bighead_carp': 'carpa cabezona',
  'fish.bighead_carp_look':
    'Mayor que la plateada, manchada de oscuro y con una cabeza enorme. Anda sobre las fosas.',
  'fish.vimba': 'vimba',
  'fish.vimba_look':
    'Estilizada, de morro abultado y dorso oscuro. Sube el río en bancos.',
  'fish.sabrefish': 'pez sable',
  'fish.sabrefish_look':
    'Un sable plano: espalda recta, vientre curvo, boca hacia arriba. Persigue alevines en la corriente.',
  'fish.shemaya': 'shemaya',
  'fish.shemaya_look':
    'Pececillo plateado y estrecho, de dorso oscuro. Come en superficie en aguas con corriente.',
  'fish.bleak': 'alburno',
  'fish.bleak_look':
    'Pequeño, de plata viva y boca hacia arriba. Bulle en superficie en bancos numerosos.',
  'fish.moderlieschen': 'moderlieschen',
  'fish.moderlieschen_look':
    'Diminuto y casi transparente. Vive pegado a la superficie de las balsas quietas.',
  'fish.gudgeon': 'gobio de río',
  'fish.gudgeon_look':
    'Moteado, con dos barbillas cortas y el vientre plano. Descansa sobre la arena de las tablas.',
  'fish.schneider': 'alburno de dos rayas',
  'fish.schneider_look':
    'Parece un alburno, pero lleva dos rayas oscuras a lo largo del flanco. Busca el agua rápida.',
  'fish.amur_bream': 'brema del Amur',
  'fish.amur_bream_look':
    'La brema del Amur: más estrecha que la nuestra, de espalda recta y escama fina. Va en bancos.',
  'fish.volga_nase': 'boga del Volga',
  'fish.volga_nase_look':
    'La boga de los afluentes del Volga, más clara que la del Dniéper. Raspa piedras en los rápidos.',
  'fish.bitterling': 'amarguillo',
  'fish.bitterling_look':
    'Diminuto y de cuerpo alto, con una raya irisada en el flanco. Solo vive donde hay almejas de río.',
  'fish.amur_chebak': 'chebak del Amur',
  'fish.amur_chebak_look':
    'El rutilo del Amur: plateado, de dorso oscuro. Se agrupa en los brazos tranquilos.',
  'fish.skygazer': 'carpa depredadora',
  'fish.skygazer_look':
    'Depredador de boca muy levantada y espalda alta. Caza alevines a media agua en el Amur.',
  'fish.yellowcheek': 'carpa de mejilla amarilla',
  'fish.yellowcheek_look':
    'Gran depredador del Amur con una mancha amarilla en la mejilla. Rompe los bancos en la corriente.',
  'fish.asp': 'aspio',
  'fish.asp_look':
    'Estilizado y plateado, con la mandíbula inferior saliente. Golpea a los alevines en superficie.',

  // ── salmónidos ──────────────────────────────────────────────────────────
  'fish.brown_trout': 'trucha común',
  'fish.brown_trout_look':
    'Moteada, con puntos rojos rodeados de un halo claro. Aguanta tras las piedras en arroyos fríos.',
  'fish.lake_trout': 'trucha lacustre',
  'fish.lake_trout_look':
    'Trucha grande y plateada de lagos profundos, con manchas oscuras. Sube a los bajíos al anochecer.',
  'fish.rainbow_trout': 'trucha arcoíris',
  'fish.rainbow_trout_look':
    'Plateada, con una banda rosa en el flanco y pintas negras. Se mantiene a media agua.',
  'fish.sea_trout': 'reo',
  'fish.sea_trout_look':
    'Trucha migradora: plateada del mar, se oscurece en el río. Sube a contracorriente a desovar.',
  'fish.salmon': 'salmón atlántico',
  'fish.salmon_look':
    'Poderoso y plateado, con cruces negras sobre la línea lateral. Descansa en las fosas de la subida.',
  'fish.arctic_char': 'salvelino ártico',
  'fish.arctic_char_look':
    'Dorso oscuro, manchas claras sin halo, vientre de rosa a rojo intenso. Quiere agua helada.',
  'fish.palia': 'salvelino palia',
  'fish.palia_look':
    'El salvelino de los lagos profundos del norte: oscuro, con el borde blanco en las aletas bajas.',
  'fish.taimen': 'taimen',
  'fish.taimen_look':
    'Salmón de río enorme, de cabeza plana y cola roja. El dueño de los ríos de Siberia.',
  'fish.danube_salmon': 'salmón del Danubio',
  'fish.danube_salmon_look':
    'El taimen del Danubio: pardo cobrizo, con pintas finas y cola ancha. Vive en las pozas hondas.',
  'fish.marble_trout': 'trucha marmórea',
  'fish.marble_trout_look':
    'Gran trucha de los ríos balcánicos: el flanco va jaspeado y no tiene ni un punto rojo.',
  'fish.lenok': 'lenok',
  'fish.lenok_look':
    'Oscuro, con pintas finas y morro romo. Se pone en los rápidos de los ríos siberianos.',
  'fish.sevan_trout': 'trucha del Seván',
  'fish.sevan_trout_look':
    'La trucha del lago Seván: plateada, con manchas oscuras escasas. Se queda en lo hondo.',

  // ── coregonos ───────────────────────────────────────────────────────────
  'fish.whitefish': 'coregono',
  'fish.whitefish_look':
    'Plateado, de boca inferior y escama pequeña y prieta. Va en bancos junto al fondo de lagos fríos.',
  'fish.vendace': 'coregono vendace',
  'fish.vendace_look':
    'Coregono pequeño de boca hacia arriba y dorso azulado. Se mantiene a media agua.',
  'fish.peled': 'peled',
  'fish.peled_look':
    'Coregono de cuerpo alto, cabeza oscura y boca terminal. Recoge plancton a media agua.',
  'fish.omul': 'omul',
  'fish.omul_look':
    'El coregono del Baikal: estilizado y de ojos grandes. Sigue al plancton en bancos densos.',
  'fish.broad_whitefish': 'coregono chir',
  'fish.broad_whitefish_look':
    'Coregono jorobado de los ríos del norte, de hocico grueso y boca inferior. Come en el fondo.',
  'fish.muksun': 'muksun',
  'fish.muksun_look':
    'El coregono de los ríos siberianos: plateado, de morro agudo. Anda justo sobre el fondo.',
  'fish.nelma': 'nelma',
  'fish.nelma_look':
    'Salmón blanco de sangre coregona: grande y de boca ancha. Caza alevines en los ríos del norte.',
  'fish.grayling': 'tímalo',
  'fish.grayling_look':
    'Dorso oscuro y una vela enorme y moteada por aleta dorsal. Aguanta tras las piedras.',
  'fish.siberian_grayling': 'tímalo siberiano',
  'fish.siberian_grayling_look':
    'Mayor que el europeo, con la vela más viva y ribeteada de rojo. Busca el agua rápida.',

  // ── pércidos ────────────────────────────────────────────────────────────
  'fish.perch': 'perca',
  'fish.perch_look':
    'Rayada, con la dorsal espinosa y las ventrales rojas. Caza en grupos pequeños.',
  'fish.zander': 'lucioperca',
  'fish.zander_look':
    'Gris plateada, con colmillos y cresta espinosa. Trabaja el fondo, los cortados y las fosas.',
  'fish.volga_zander': 'lucioperca del Volga',
  'fish.volga_zander_look':
    'Como la lucioperca, pero menor, sin colmillos y de morro romo. Se pone en fosas de arena.',
  'fish.ruffe': 'acerina',
  'fish.ruffe_look':
    'Espinosa, pardo gris con pintas oscuras, cubierta de baba. Se tumba en el fondo hondo.',
  'fish.donets_ruffe': 'acerina del Don',
  'fish.donets_ruffe_look':
    'Acerina de morro alargado y color amarillento. Busca la arena de las corrientes fluviales.',
  'fish.zingel': 'zíngel',
  'fish.zingel_look':
    'Largo y cilíndrico, con bandas oscuras y dos dorsales separadas. Pegado al fondo.',
  'fish.streber': 'zíngel streber',
  'fish.streber_look':
    'Más fino y menor que el zíngel, con las manchas del flanco más marcadas. Vive en rápidos pedregosos.',
  'fish.percarina': 'percarina',
  'fish.percarina_look':
    'Perca diminuta y semitransparente de los estuarios, de ojos grandes. Va en bancos a media agua.',

  // ── esturiones ──────────────────────────────────────────────────────────
  'fish.sterlet': 'esterlete',
  'fish.sterlet_look':
    'Esturión pequeño de morro fino y puntiagudo y barbillas con flecos. Trabaja el fondo en corriente.',
  'fish.russian_sturgeon': 'esturión ruso',
  'fish.russian_sturgeon_look':
    'Esturión de morro romo con hileras de escudos óseos en el lomo. Come en el fondo de las fosas.',
  'fish.siberian_sturgeon': 'esturión siberiano',
  'fish.siberian_sturgeon_look':
    'El esturión de los ríos siberianos: más oscuro que el ruso y de morro más corto. No deja el fondo.',
  'fish.stellate_sturgeon': 'esturión estrellado',
  'fish.stellate_sturgeon_look':
    'Esturión de morro largo como una espada y cuerpo estrecho. Escarba la arena en lo hondo.',
  'fish.beluga': 'beluga',
  'fish.beluga_look':
    'El mayor pez de agua dulce que existe: boca enorme, morro romo. Vive en las fosas más profundas.',
  'fish.ship_sturgeon': 'esturión ship',
  'fish.ship_sturgeon_look':
    'Esturión de labio inferior entero: a la vista, un punto medio entre el estrellado y el ruso.',
  'fish.kaluga': 'kaluga',
  'fish.kaluga_look':
    'La beluga del Amur: un gigante de boca ancha. Se queda en el fondo de los grandes remansos.',
  'fish.paddlefish': 'pez espátula',
  'fish.paddlefish_look':
    'Pariente del esturión con una pala larga en lugar de morro. Filtra plancton con la boca abierta.',

  // ── siluros ─────────────────────────────────────────────────────────────
  'fish.catfish': 'siluro',
  'fish.catfish_look':
    'Cuerpo oscuro y sin escamas, boca ancha, dos barbillas largas. Yace en fosas y bajo troncos.',
  'fish.channel_catfish': 'bagre de canal',
  'fish.channel_catfish_look':
    'Moteado, de cola ahorquillada y cuatro pares de barbillas. Recorre el fondo en grupo.',
  'fish.amur_catfish': 'bagre del Amur',
  'fish.amur_catfish_look':
    'Bagre pequeño con bandas amarillas y espinas que se traban. Chirría al tenerlo en la mano.',
  'fish.clarias': 'pez gato africano',
  'fish.clarias_look':
    'Anguiliforme, con la dorsal larguísima, y respira aire. Vive en agua templada y turbia.',

  // ── lucios ──────────────────────────────────────────────────────────────
  'fish.pike': 'lucio',
  'fish.pike_look':
    'Alargado, verde oscuro con motas amarillas, la boca llena de dientes. Acecha entre hierba y troncos.',
  'fish.amur_pike': 'lucio del Amur',
  'fish.amur_pike_look':
    'El lucio del Amur: plateado y con pintas oscuras finas en vez de motas amarillas. Vive en los brazos.',

  // ── centrárquidos ───────────────────────────────────────────────────────
  'fish.pumpkinseed': 'pez sol',
  'fish.pumpkinseed_look':
    'Vistoso y redondo, con una mancha naranja en el opérculo. Revolotea junto a la hierba.',
  'fish.largemouth_bass': 'black bass',
  'fish.largemouth_bass_look':
    'Verde, con una banda oscura en el flanco y la boca que pasa del ojo. Vive entre troncos.',
  'fish.smallmouth_bass': 'black bass de boca pequeña',
  'fish.smallmouth_bass_look':
    'Bronceado, con barras oscuras cruzando el flanco. Prefiere fondo de piedra y agua con corriente.',

  // ── gobios ──────────────────────────────────────────────────────────────
  'fish.round_goby': 'gobio redondo',
  'fish.round_goby_look':
    'Oscuro, con una mancha negra en la dorsal; las ventrales forman una ventosa. Se sienta en el fondo.',
  'fish.sand_goby': 'gobio de arena',
  'fish.sand_goby_look':
    'Claro, color arena, con el flanco salpicado de pintas. Vive en los bajíos arenosos.',
  'fish.tubenose_goby': 'gobio de nariz tubular',
  'fish.tubenose_goby_look':
    'Diminuto, con los tubos de las fosas nasales asomando sobre el labio. Vive entre las piedras.',

  // ── lochas ──────────────────────────────────────────────────────────────
  'fish.weatherfish': 'locha de estanque',
  'fish.weatherfish_look':
    'Larga y serpentina, con rayas oscuras y diez barbillas. Traga aire para vivir en agua estancada.',
  'fish.spined_loach': 'colmilleja',
  'fish.spined_loach_look':
    'Estrecha, con una fila de manchas oscuras y una espina plegable bajo el ojo. Se entierra en la arena.',
  'fish.stone_loach': 'locha de piedra',
  'fish.stone_loach_look':
    'Lisa y moteada, con seis barbillas. Se esconde bajo las piedras de los arroyos limpios.',

  // ── eperlanos ───────────────────────────────────────────────────────────
  'fish.smelt': 'eperlano',
  'fish.smelt_look':
    'De plata translúcida, con dientes finos y un olor claro a pepino fresco. Va en bancos apretados.',
  'fish.snetok': 'eperlano enano',
  'fish.snetok_look':
    'Eperlano de lago, no más largo que un dedo. Se agrupa en el agua fría abierta.',

  // ── lampreas ────────────────────────────────────────────────────────────
  'fish.river_lamprey': 'lamprea de río',
  'fish.river_lamprey_look':
    'No es un pez: serpentina, sin mandíbulas, con una ventosa redonda en lugar de boca.',
  'fish.ukrainian_lamprey': 'lamprea ucraniana',
  'fish.ukrainian_lamprey_look':
    'Lamprea pequeña de arroyo que de adulta no come nada. Las larvas pasan años enterradas en el limo.',

  // ── otros ───────────────────────────────────────────────────────────────
  'fish.rotan': 'dormilón del Amur',
  'fish.rotan_look':
    'Oscuro y cabezón, de boca grande. Se adueña de las balsas pequeñas y se come todo lo que vive en ellas.',
  'fish.snakehead': 'pez cabeza de serpiente',
  'fish.snakehead_look':
    'Cabeza de serpiente cubierta de escudos y dorsal larguísima. Respira aire y guarda a sus crías.',
  'fish.burbot': 'lota',
  'fish.burbot_look':
    'El único bacalao de agua dulce: viscoso, jaspeado, con una barbilla en el mentón. Revive con el frío.',
  'fish.eel': 'anguila',
  'fish.eel_look':
    'Serpentina y resbaladiza, con branquias diminutas. Sale a los bajíos de noche y de día se entierra.',
  'fish.bullhead': 'cavilat',
  'fish.bullhead_look':
    'Cabezón, aplanado, jaspeado y sin escamas. Se sienta bajo las piedras de los arroyos limpios.',
  'fish.bigmouth_buffalo': 'búfalo bocagrande',
  'fish.bigmouth_buffalo_look':
    'Como un carpín enorme de espalda gruesa, con la boca hacia delante. Come a media agua.',
  'fish.smallmouth_buffalo': 'búfalo bocachica',
  'fish.smallmouth_buffalo_look':
    'Más oscuro que el bocagrande y con la boca por debajo. Recoge el alimento del propio fondo.',
  'fish.tilapia': 'tilapia del Nilo',
  'fish.tilapia_look':
    'De cuerpo alto, con barras cruzando el flanco y dorsal larga. Necesita agua templada.',
};
